export const setToLocalStorage = (payload) => {
  Object.keys(payload).forEach((data) => {
    localStorage.setItem(data, payload[data]);
  });
};

export function AffiliateUserCredentials() {
  const affiliateAccessToken = localStorage.getItem('affiliateAccessToken');
  return {
    Authorization: `bearer ${affiliateAccessToken}`,
  };
}
